// extracted by mini-css-extract-plugin
export var progressContainer = "_ic-0";